import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Search } from '@mui/icons-material';



const EmptySearchState: React.FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '400px',
                textAlign: 'center',
                px: 3,
            }}
        >
            <Stack spacing={3} alignItems="center">
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '12px',
                        backgroundColor: '#3B82F6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1,
                    }}
                >
                    <Search 
                        style={{ 
                            fontSize: 32, 
                            color: 'white' 
                        }} 
                    />
                </Box>

                {/* Main heading */}
                <Typography 
                    variant="h6" 
                    sx={{ 
                        fontWeight: 700,
                        color: 'text.primary',
                        mb: 0.5,
                    }}
                >
                    Nothing matched your keyword
                </Typography>

                {/* Subtitle */}
                <Typography 
                    variant="body2" 
                    sx={{ 
                        color: 'text.secondary',
                        maxWidth: '320px',
                        lineHeight: 1.5,
                    }}
                >
                    Try adjusting your search to see more results
                </Typography>
            </Stack>
        </Box>
    );
};

export default EmptySearchState;